// import { API_FIELDS } from 'library/constants/models/browse-item';
import * as constants from './constants';
import { FILTER_KEYS, SORT_DIRECTION as DIRECTIONS, TYPE } from './fixtures';

// todo - consider move filters/query data to separate reducers
export const initialState = {
  loading: false,
  data: [],
  error: null,
  filters: {
    [FILTER_KEYS.PAGE]: 1,
    [FILTER_KEYS.PER_PAGE]: 50,
    [FILTER_KEYS.HAS_MORE]: false,
    [FILTER_KEYS.SORT_DIRECTION]: DIRECTIONS.DESC,
    [FILTER_KEYS.TYPE]: TYPE.ITEM,
    [FILTER_KEYS.QUANTITY]: null,
    [FILTER_KEYS.CATEGORIES]: [],
    [FILTER_KEYS.MANUFACTURERS]: [],
    [FILTER_KEYS.STORAGE]: [],
    [FILTER_KEYS.TAGS]: [],
    [FILTER_KEYS.COLORS]: [],
    [FILTER_KEYS.ITEMS]: [],
    [FILTER_KEYS.QUERY]: '',
  },
};

export const browseItemsReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_BROWSE_ITEMS:
    return {
      ...state,
      loading: true,
    };
  case constants.SET_BROWSE_ITEMS_FILTERS:
    return {
      ...state,
      ...(action.payload[FILTER_KEYS.TYPE] !== state.filters[FILTER_KEYS.TYPE] && state.data.length ? { data: [] } : {}),
      // data: [],
      deletedIds: [],
      filters: {
        ...(action.payload && Object.keys(action.payload).length !== 0 ? {
          ...state.filters,
          ...action.payload,
          ...(action.payload[FILTER_KEYS.TYPE] === TYPE.SET && [DIRECTIONS.MOST_LIKED, DIRECTIONS.CATEGORY, DIRECTIONS.MANUFACTURER, DIRECTIONS.NAME, DIRECTIONS.STORAGE].includes(state.filters[FILTER_KEYS.SORT_DIRECTION]) ? {
            [FILTER_KEYS.SORT_DIRECTION]: DIRECTIONS.DESC,
          } : {}),
          [FILTER_KEYS.PAGE]: 1,
          [FILTER_KEYS.HAS_MORE]: false,
        } : JSON.parse(JSON.stringify(initialState.filters))),
      },
    };
  case constants.GET_BROWSE_ITEMS_SUCCESS:
    return {
      ...state,
      loading: false,
      // eslint-disable-next-line max-len
      data: [...(action.payload.filters[FILTER_KEYS.PAGE] !== 1 ? state.data : []), ...action.payload.data],
      filters: {
        ...state.filters,
        ...action.payload.filters,
      },
    };
  case constants.GET_BROWSE_ITEMS_ERROR:
    return {
      ...state,
      loading: false,
      error: action.payload,
      filters: {
        ...state.filters,
        [FILTER_KEYS.HAS_MORE]: false,
      },
    };
  case constants.UPDATE_BROWSE_ITEMS:
    return {
      ...state,
      data: action.payload.data,
    };
  case constants.RESET_BROWSE_ITEMS:
    return initialState;
  default:
    return state;
  }
};

const initialActionState = {
  loading: false,
  selectedIds: [],
  openedItemId: null,
};

export const browseItemsActionReducer = (state = initialActionState, action) => {
  switch (action.type) {
  case constants.SELECT_BROWSE_ITEM:
    return { ...state, selectedIds: [...state.selectedIds, action.payload.id] };
  case constants.DESELECT_BROWSE_ITEM:
    return { ...state, selectedIds: state.selectedIds.filter((id) => id !== action.payload.id) };
  case constants.DESELECT_MANY_BROWSE_ITEMS:
    return {
      ...state,
      selectedIds: state.selectedIds.filter((id) => !action.payload.ids.includes(id)),
    };
  case constants.OPEN_BROWSE_ITEM:
    return { ...state, openedItemId: action.payload.id };
  case constants.CLOSE_BROWSE_ITEM:
    return { ...state, openedItemId: null };
  case constants.RESET_BROWSE_ITEMS_ACTIONS:
    return initialActionState;
  default:
    return state;
  }
};
